import { Select } from '@/components/ui/Select'

const currentYear = new Date().getFullYear()

const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => {
  const y = String(currentYear - 2 + i)
  return { value: y, label: y }
})

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => {
  const m = i + 1
  return {
    value: String(m),
    label: new Date(2000, i).toLocaleString(undefined, { month: 'long' }),
  }
})

export interface MonthYearPickerProps {
  year: number
  month: number
  onYearChange: (year: number) => void
  onMonthChange: (month: number) => void
  className?: string
  /** Omit the "Year"/"Month" field labels — use in a compact single-row toolbar. */
  hideLabels?: boolean
}

export function MonthYearPicker({
  year,
  month,
  onYearChange,
  onMonthChange,
  className,
  hideLabels = false,
}: MonthYearPickerProps): React.ReactElement {
  return (
    <div className={`flex ${hideLabels ? 'items-center' : 'items-end'} gap-3 ${className ?? ''}`}>
      <Select
        label={hideLabels ? undefined : 'Year'}
        options={YEAR_OPTIONS}
        value={String(year)}
        onChange={(v) => v && onYearChange(Number(v))}
        className="w-28"
      />
      <Select
        label={hideLabels ? undefined : 'Month'}
        options={MONTH_OPTIONS}
        value={String(month)}
        onChange={(v) => v && onMonthChange(Number(v))}
        className="w-40"
      />
    </div>
  )
}

MonthYearPicker.displayName = 'MonthYearPicker'
